import { render, staticRenderFns } from "./UpdateDepartmentDialog.vue?vue&type=template&id=a0e179e0&scoped=true&"
import script from "./UpdateDepartmentDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateDepartmentDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateDepartmentDialog.vue?vue&type=style&index=0&id=a0e179e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e179e0",
  null
  
)

export default component.exports